import React, { useEffect } from 'react'
import { Button, Row, Typography, Collapse } from 'antd'
import { PlusCircleOutlined, CaretRightOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from '~/Store/hooks'
import { getDefaultOrganization } from '~/Store/User/selectors'
import styles from './Roles.module.less'
import { ScrollBar } from '~/Components/ScrollBar'
import { WaitOverlay } from '~/Components'
import { roleModalName, waitOverlayName } from './constant'
import { getListRoles } from '~/Store/Role/selectors'
import { RolesActions } from '~/Store/Role'
import { RoleModal } from './RoleModal'
import { useTranslation } from 'react-i18next'
import { RolePanelHeader } from './RolePanelHeader'
import { AssignRoleExtra } from './AssignRoleExtra'
import { UsersActions } from '~/Store/AdminUser'

const { Panel } = Collapse

export const AdminRoles = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const defaultOrg = useAppSelector(getDefaultOrganization)
  const roleAdminData = useAppSelector(getListRoles)

  const fetchRolesAdmin = async () => {
    dispatch(RolesActions.getRolesRequest())
    dispatch(
      UsersActions.getUsersRequest({
        paging: false,
      }),
    )
  }

  useEffect(() => {
    fetchRolesAdmin()
  }, [defaultOrg])

  const openRoleModal = () => {
    dispatch(RolesActions.setModalState({ name: roleModalName, value: true }))
  }

  return (
    <WaitOverlay name={waitOverlayName} size="large">
      <RoleModal />
      <Row align="stretch">
        <Typography.Title style={{ flex: 1 }} level={4}>
          {t('rolesManagement')}
        </Typography.Title>
        <Button
          icon={<PlusCircleOutlined />}
          type="primary"
          onClick={openRoleModal}
        >
          {t('newRole')}
        </Button>
      </Row>
      <div className={styles.organizationRoles} style={{ marginTop: '15px' }}>
        <ScrollBar style={{ paddingRight: '16px', marginRight: '-16px' }}>
          <Collapse
            activeKey={[]}
            onChange={() => {}}
            ghost
            className={styles.roleCollapse}
            expandIconPosition="right"
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            {roleAdminData?.map(role => (
              <Panel
                header={<RolePanelHeader role={role} />}
                key={role.id}
                className={styles.roleCollapsePanel}
                extra={<AssignRoleExtra role={role} />}
              >
                {/* <UserList role={role} /> */}
              </Panel>
            ))}
          </Collapse>
        </ScrollBar>
      </div>
    </WaitOverlay>
  )
}
